import { auth } from 'systems/api'

export const login = async () => {
  return auth.setToken('loggedIn')
}

export const logout = async () => {
  return auth.removeToken()
}
